@if (_strategy()?.state === "ENABLED" && constraint()) {
  <div *transloco="let t" class="flex h-full items-center">
    <span
      [class]="constraint()!.icon"
      [ngClass]="{
        'h-6 w-6': this._size() === FblModeSize.small,
        'h-[30px] w-[30px]': this._size() === FblModeSize.large,
        'text-yellow-500': this.isWarning(),
      }"
      [iTooltip]="t(constraint()!.title)"
      iTooltipPlacement="bottom"
    ></span>
  </div>
}
